import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import SaudeService from '../../../services/saude'
import Remume from './remume';

const ListarRemumes = () => {

    const [remumes, setRemumes] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchRemumes() {
        const response = await SaudeService.listarRemume();
        if (response.data.length >= 1) {
            setRemumes(response.data)
            setVazio(false)
        } else {
            setRemumes([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchRemumes();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setRemumes={setRemumes}
                    setVazio={setVazio}
                    remumes={remumes}
                    fetchRemumes={fetchRemumes}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h5>Relação Municipal de Medicamentos Essenciais</h5>
                    <Row xs={1} lg={3}>
                        {remumes.map((remume, index) =>
                            <Remume
                                remume={remume}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarRemumes;